import {InjectionToken} from '@angular/core';

export const TISA_AUTH_URL = new InjectionToken<string>('Provides base url of Auth API.');
